// PR-3634 contracts v4 §6.5: opens TierPlans for the email deep link (?openPlans=pro) once the user is signed in.
// Mounted once in App.js, outside the routes and the side menu's drawer, so it works on every page and on mobile.
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TierPlans from '../TierPlans/TierPlans';
import { UserRoles } from '../../Models/SubUser/SubUsers';
import { getCookie } from '../../helpers/Functions/cookies';
import { consumeOpenPlansRequest, hasOpenPlansRequest, stripOpenPlansParams } from './proTrialDeepLink';

const ProTrialPlansLauncher = ({ classes }: { classes: any }) => {
  const { currentPlan } = useSelector((state: any) => state.tiers);
  const { userRoles, isAdmin, isDebtAccount } = useSelector((state: any) => state.core);
  const { subAccount, accountSettings } = useSelector((state: any) => state.common);
  const [showTierPlans, setShowTierPlans] = useState(false);

  // getCurrentPlan has answered and the sub-account (CompanyAdmin) is known.
  const isReady = !!currentPlan?.Id && !!subAccount && !!accountSettings;

  useEffect(() => {
    if (!isReady || !hasOpenPlansRequest()) return;
    const request = consumeOpenPlansRequest();
    try {
      window.history.replaceState(window.history.state, '', stripOpenPlansParams(window.location.href));
    } catch (e) {
      // The URL keeps the parameters; the request itself is already consumed.
    }
    if (!request) return;

    // Same gate as the BillingSettings menu item (routes.tsx): company admin with the Admin role.
    const isCompanyAdmin = !!subAccount?.CompanyAdmin && userRoles === UserRoles.Admin;
    // Pages that App.js forces instead of the normal routes (debt, terms of use).
    const isTermsForced = !isAdmin && !accountSettings?.SubAccountSettings?.IsTermsApproved &&
      accountSettings?.SubAccountSettings?.IgnoranceCount === 3 && getCookie('ignoreTerm') !== 'true';
    const isBlocked = (!isAdmin && isDebtAccount === true) || isTermsForced || currentPlan?.Name === 'GRAND_FATHER';

    if (isCompanyAdmin && !isBlocked) setShowTierPlans(true);
    // Runs when the account data is ready; the request is consumed on that first run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);

  if (!showTierPlans) return null;
  return (
    <TierPlans
      classes={classes}
      isOpen={showTierPlans}
      onClose={() => setShowTierPlans(false)}
    />
  );
};

export default ProTrialPlansLauncher;
